document.addEventListener('DOMContentLoaded', function () {
  const bundleBuilder = {
    container: document.getElementById('TeaBundleBuilder'),
    bundleOptions: document.querySelectorAll('.bundle-option'),
    boxSizeOptions: document.querySelectorAll('.box-size-option'),
    subscriptionToggle: document.getElementById('subscriptionToggle'),
    selectedItemsGrid: document.querySelector('.selected-items-grid'),
    productCards: document.querySelectorAll('.product-item'),
    addToBoxButton: document.querySelector('.add-to-box-button'),
    buyNowButton: document.getElementById('BuyNowButton'),
    discountedPriceEl: document.querySelector('.discounted-price'),
    originalPriceEl: document.querySelector('.original-price'),
    selectedBoxSizeElements: document.querySelectorAll('.selected-box-size'),
    boxProgressEl: document.querySelector('.box-progress'),
    boxSizeOptionsContainer: document.querySelector('.box-size-options'),

    placeholderImage: 'product_image_placeholder.png',

    state: {
      boxSize: 3, // default, updated later
      boxPrice: 230,
      productHandle: '',
      selectedBundle: '',
      selectedItems: [],
      isSubscription: false,
      subscriptionDiscount: 20
    },

    init: function () {
      this.preloadPlaceholderImage();
      this.initializeState();
      this.bindEvents();
      this.updateUI();
    },

    preloadPlaceholderImage: function () {
      const placeholderImg = new Image();
      placeholderImg.onerror = () => {
        this.placeholderImage = 'https://cdn.shopify.com/s/files/1/0675/5646/6428/files/product_image_placeholder.png';
      };
      placeholderImg.src = this.getAssetUrl(this.placeholderImage);
    },

    getAssetUrl: function (assetName) {
      const shopUrl = window.Shopify ? window.Shopify.shop : window.location.hostname;
      return `https://cdn.shopify.com/s/files/1/0675/5646/6428/files/${assetName}`;
    },

    initializeState: function () {
      const activeBundle = document.querySelector('.bundle-option.active');
      if (activeBundle) {
        this.state.boxSize = parseInt(activeBundle.dataset.size, 10) || 3;
        this.state.boxPrice = parseInt(activeBundle.dataset.price, 10) || 230;
        this.state.productHandle = activeBundle.dataset.productHandle || '';
      }

      const subscriptionDiscountEl = document.querySelector('.subscription-benefit:last-child .benefit-text');
      if (subscriptionDiscountEl) {
        const discountText = subscriptionDiscountEl.textContent;
        const discountMatch = discountText.match(/(\d+)%/);
        if (discountMatch && discountMatch[1]) {
          this.state.subscriptionDiscount = parseInt(discountMatch[1], 10);
        }
      }
    },

    bindEvents: function () {
      const self = this;

      this.bundleOptions.forEach(option => {
        option.addEventListener('click', function () {
          const input = this.querySelector('input');
          if (!input) return;
      
          const size = parseInt(input.dataset.size, 10);
          const price = parseInt(input.dataset.price, 10);
          const productHandle = input.dataset.productHandle;
          const variantId = input.dataset.variantId;

          self.state.selectedBundle = variantId;
          self.state.boxSize = size || 3;
          self.selectBoxSize(size, price, productHandle, variantId);
        });
      });
      

      this.boxSizeOptions.forEach(option => {
        option.addEventListener('click', function () {
          const size = parseInt(this.dataset.size);
          const price = parseInt(this.dataset.price);
          const productHandle = this.dataset.productHandle;
          const variantId = this.dataset.variantId;
          self.selectBoxSize(size, price, productHandle, variantId);
          //console.log('ertert');
          
        });
      });

      this.productCards.forEach(card => {
        const addButton = card.querySelector('.product-action-button');
        if (addButton) {
          addButton.addEventListener('click', function () {
            const productId = card.dataset.productId;
             if (self.getTotalQuantity() >= self.state.boxSize) {
                  alert(`Your box can only fit ${self.state.boxSize} items. Please adjust your selection.`);
                  return;
                }

            const existing = self.state.selectedItems.find(item => item.id === productId);
            if (!existing) {
              const productTitle = card.dataset.title;
              let productImage;
              const imageElement = card.querySelector('.product-image');
              productImage = (imageElement && imageElement.src && imageElement.src !== 'undefined' && imageElement.src !== '') ? imageElement.src : self.getAssetUrl(self.placeholderImage);

              self.state.selectedItems.push({
                id: productId,
                title: productTitle,
                image: productImage,
                quantity: 1
              });

              card.classList.add('selected');
              self.attributesToCart();
              self.renderQuantityAdjuster(card, productId);
              self.updateUI();
            }
          });
        }
      });

      if (this.subscriptionToggle) {
        this.subscriptionToggle.addEventListener('change', function () {
          self.state.isSubscription = this.checked;
          self.updateUI();
        });
      }

      if (this.addToBoxButton) {
        this.addToBoxButton.addEventListener('click', function () {
          document.querySelector('.box-summary').scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        });
      }

      if (this.buyNowButton) {
        this.buyNowButton.addEventListener('click', function () {
          self.addToCart(false);
        });
      }
    },
    attributesToCart: function() {
      const productForm = document.getElementsByClassName('cart-form')[0];
      
      // First remove ALL existing tea properties
      const existingTeaInputs = productForm.querySelectorAll('input[name^="properties[Tea "]');
      existingTeaInputs.forEach(input => input.remove());
      
      // Now add properties for remaining items with proper reindexing
      this.state.selectedItems.forEach((item, index) => {
        const inputName = `properties[Tea ${index + 1}]`;
        const textInput = document.createElement('input');
        textInput.type = 'hidden';
        textInput.name = inputName;
        textInput.value = `${item.title} (Qty: ${item.quantity})`;
        productForm.appendChild(textInput);
      });
    },
    
    selectBoxSize: function (size, price, productHandle, variantId) {
      //console.log(size+' <'+ this.state.boxSize +'&&'+ this.getTotalQuantity() +'>'+ size);
      
      if (this.getTotalQuantity() > size) {
        if (!confirm(`Reducing the box size to ${size} will clear some selections. Continue?`)) return;
        this.state.selectedItems = [];
        this.removeFromBundleProperties();
        this.resetProductCards();
      }

      this.state.boxSize = size;
      this.state.boxPrice = price || (size === 3 ? 150 : 270);
      if (productHandle) this.state.productHandle = productHandle;

      this.updateUI();
      this.updateUrlWithVariant(variantId);
    },

    updateUrlWithVariant: function (variantId) {
      if (!variantId) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    },

    resetProductCards: function () {
      this.productCards.forEach(card => {
        card.classList.remove('selected');
        const adjuster = card.querySelector('.quantity-adjuster');
        if (adjuster) {
          const addButton = card.querySelector('.product-action-button');
          if (addButton) addButton.style.display = 'block';
          adjuster.remove();
        }
      });
    },

    getTotalQuantity: function () {
      return this.state.selectedItems.reduce((sum, item) => sum + item.quantity, 0);
    },

    renderQuantityAdjuster: function (card, productId) {
      const addButton = card.querySelector('.product-action-button');
      if (addButton) addButton.style.display = 'none';

      const existingAdjuster = card.querySelector('.quantity-adjuster');
      if (existingAdjuster) existingAdjuster.remove();

      const adjuster = document.createElement('div');
      adjuster.className = 'quantity-adjuster';
      adjuster.dataset.productId = productId;
      adjuster.innerHTML = `
        <button class="decrease">–</button>
        <span class="quantity">1</span>
        <button class="increase">＋</button>
        <button class="remove quantity-remove-btn">X</button>
      `;
      card.appendChild(adjuster);
      const decreaseBtn = adjuster.querySelector('.decrease');
      const increaseBtn = adjuster.querySelector('.increase');
      const removeBtn = adjuster.querySelector('.remove');
      const quantityEl = adjuster.querySelector('.quantity');

      decreaseBtn.addEventListener('click', () => {
        let item = this.state.selectedItems.find(i => i.id === productId);
        if (item && item.quantity > 1) {
          item.quantity--;
          quantityEl.textContent = item.quantity;
          this.attributesToCart(); //update quantity to cart
          this.updateUI();
        }
      });

      increaseBtn.addEventListener('click', () => {
        if (this.getTotalQuantity() >= this.state.boxSize) {
            alert(`Your box can only fit ${this.state.boxSize} items. Please adjust your selection.`);
            return;
        }
        let item = this.state.selectedItems.find(i => i.id === productId);
        if (item) {
          item.quantity++;
          quantityEl.textContent = item.quantity;
          this.attributesToCart(); //update quantity to cart
          this.updateUI();
        }
      });

      removeBtn.addEventListener('click', () => {
        this.removeItem(productId);
        this.removeFromBundleProperties(productId);
        card.classList.remove('selected');
        adjuster.remove();
        const addBtn = card.querySelector('.product-action-button');
        if (addBtn) addBtn.style.display = 'block';
        this.updateUI();
      });
    },

    removeItem: function (productId) {
      this.state.selectedItems = this.state.selectedItems.filter(item => item.id !== productId);
    },
    removeFromBundleProperties: function(productId = 0) {
      if (!productId) return; // Don't allow clearing all without rebuilding
      
      // Just remove the specific product from state
      this.state.selectedItems = this.state.selectedItems.filter(item => item.id !== productId);
      
      // Then rebuild all properties with proper indexing
      this.attributesToCart();
    },
    // Add this to your component to help find products by ID
    getProductTitle: function(productId) {
      const product = this.state.selectedItems.find(item => item.id === productId);
      return product ? product.title : '';
    },

    renderSelectedItems: function () {
      const container = this.boxSizeOptionsContainer;
      if (!container) return;

      container.innerHTML = '';

      if (this.state.selectedItems.length > 0) {
        container.classList.remove('hidden');
      } else {
        container.classList.add('hidden');
      }

      this.state.selectedItems.forEach(item => {
        const itemDiv = document.createElement('div');
        itemDiv.className = 'selected-item';
        itemDiv.innerHTML = `
          <img src="${item.image}" alt="${item.title}" class="selected-item-image" />
          <div class="selected-item-info">
            <span class="selected-item-title">${item.title}</span>
            <span class="selected-item-qty">Qty: ${item.quantity}</span>
          </div>
        `;
        container.appendChild(itemDiv);
      });
    },

    updateUI: function () {
      const remaining = this.state.boxSize - this.getTotalQuantity();

      if (this.addToBoxButton) {
        // Wait for translations to be available
        if (!window.translations) {
          // Retry after a short delay
          setTimeout(() => this.updateUI(), 50);
          return;
        }
        this.addToBoxButton.textContent = remaining > 0
          ? window.translations.selectMoreBoxes.replace('%{count}', remaining)
          : window.translations.boxIsFull;
        this.addToBoxButton.disabled = remaining <= 0;
      }

      if (this.boxProgressEl) {
        this.boxProgressEl.textContent = `${this.getTotalQuantity()} / ${this.state.boxSize} selected`;
      }

      this.state.selectedItems.forEach(item => {
        const card = document.querySelector(`.product-item[data-product-id="${item.id}"]`);
        if (card) {
          const quantityEl = card.querySelector('.quantity-adjuster .quantity');
          if (quantityEl) quantityEl.textContent = item.quantity;
        }
      });

      const discount = this.state.isSubscription ? this.state.subscriptionDiscount : 0;
      const discountedPrice = this.state.boxPrice - (this.state.boxPrice * discount / 100);

      if (this.discountedPriceEl) {
        this.discountedPriceEl.textContent = `₹${discountedPrice}`;
      }

      if (this.originalPriceEl) {
        this.originalPriceEl.textContent = this.state.isSubscription ? `₹${this.state.boxPrice}` : '';
      }

      this.selectedBoxSizeElements.forEach(el => {
        el.textContent = this.state.boxSize;
      });

      //this.renderSelectedItems();
    },

    addToCart: function () {
      if (this.getTotalQuantity() === 0) {
        this.buyNowButton.disabled = this.getTotalQuantity() === 0;
        alert('Please select at least one tea for your box.');
        return;
      }
      const items = this.state.selectedItems.map(item => ({
        id: item.id,
        quantity: item.quantity
      }));
      console.log('Adding to cart:', items);
    }
  };

  bundleBuilder.init();
});
